module.exports = __webpack_public_path__ + "static/media/telephone.0825f0d0.svg";